import client from './client';

const helpApi = {
  getPage: (pageKey) => client.get(`/help/${pageKey}`).then(r => r.data),
  getRoutes: () => client.get('/help/routes').then(r => r.data),
};

export default helpApi;
